<template src="./index.html"></template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import { jump } from '../../util/jumpPage'
import ClaimDialog from '_c/claimDialog'

export default {
  name : 'authapply',

  components: {
    ClaimDialog
  },

  data() {
    return {
      dialogVisible: true,
      pageNum: 1,
      pageSize: 10,
      pageSizeOptionVisible: false,
      pageNumOptionVisible: false,
      pageSizeOptions: [10, 20, 50],
		}
	},

  async asyncData ({ store }) {
    const DISPATCH = store.dispatch

    return await Promise.all([
      DISPATCH('commonData/setCurrentPage', 'authapply'),
      DISPATCH('dataAuthApply/getInstitutionList', {
        pageNum: 1,
        pageSize: 10
      })
    ])
  },

  computed: {
    ...mapState('dataAuthApply', {
      tableData: s => s.listData.list,
      totalNum: s => s.listData.total
    }),
    totalPage: function () {
      return Math.ceil(this.totalNum / this.pageSize) || 1
    }
  },

	methods: {
    ...mapActions('dataUserInfo', ['getUserInfo']),
		...mapActions('dataAuthApply', ['getInstitutionList']),

    async fetchInstitutionList ({ pageNum, pageSize }) {
      const res = await this.getInstitutionList({
        pageNum,
        pageSize
      })

      if (!res) {
        return
      }

      const { listData } = res
    },

    stopBubble (e) {
      if (e && e.stopPropagation) {
        e.stopPropagation()
      } else {
        window.event.cancelBubble = true
      }
    },

    clickPageNumOption (e) {
      this.pageNumOptionVisible = !this.pageNumOptionVisible
      this.stopBubble(e)
    },

    clickPageSizeOption (e) {
      this.pageSizeOptionVisible = !this.pageSizeOptionVisible
      this.stopBubble(e)
    },

    closeAllOptions () {
      this.pageNumOptionVisible = false
      this.pageSizeOptionVisible = false
    },

    choosePageSize (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1

      this.fetchInstitutionList({ pageNum: this.pageNum, pageSize: this.pageSize })
    },

    choosePageNum (pageNum) {
      if (this.pageNum < 1 || this.pageNum > this.totalPage) {
        return
      }
      this.pageNum = pageNum

      this.fetchInstitutionList({ pageNum: this.pageNum, pageSize: this.pageSize })
    }

	},
}
</script>

<style scoped src="./index.less" lang="less">
</style>
